module.exports = {"links":[{"icon":"home","href":"/","text":"Home"},{"icon":"rocket","href":"/play","text":"Playground"},{"icon":"github","href":"/collection","text":"Collection"},{"icon":"message","href":"/contact","text":"Contact"}]}


//////////////////
// WEBPACK FOOTER
// ./src/Components/Header/setting.json
// module id = 1092
// module chunks = 0